var map = {
	"./zh-cn": 1209,
	"./zh-cn.js": 1209
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1910;


//////////////////
// WEBPACK FOOTER
// ./~/moment/locale zh-cn
// module id = 1910
// module chunks = 148